<template>
  <modal-main>
    <template #fullBody>
      <div class="p-modal-notify-thanks-point-denial">
        <div class="p-modal-notify-thanks-point-denial__header">
          <IconUserImage :size="profileIconSize">
            <img
              v-if="user.user_image"
              class="p-modal-notify-thanks-point-denial__avatar"
              :src="user.user_image"
              :alt="user.user_name"
            />
          </IconUserImage>
          <span class="p-modal-notify-thanks-point-denial__name" data-translate-skip>
            {{ user.user_name }}
          </span>
        </div>
        <div class="p-modal-notify-thanks-point-denial__body">
          <ul class="p-modal-notify-thanks-point-denial__body__list">
            <li class="p-modal-notify-thanks-point-denial__body__list__item">
              <div class="p-modal-notify-thanks-point-denial__body__panel">
                <SmallText :size="14">送付ポイント</SmallText>
                <div
                  class="p-modal-notify-thanks-point-denial__body__panel__text"
                >
                  <p>{{ transaction.points }}</p>
                </div>
              </div>
            </li>

            <li class="p-modal-notify-thanks-point-denial__body__list__item">
              <div class="p-modal-notify-thanks-point-denial__body__panel">
                <SmallText :size="14">タイトル</SmallText>
                <div
                  class="p-modal-notify-thanks-point-denial__body__panel__text"
                >
                  <p data-translate-skip>{{ title }}</p>
                </div>
              </div>
            </li>

            <li class="p-modal-notify-thanks-point-denial__body__list__item">
              <div class="p-modal-notify-thanks-point-denial__body__panel">
                <SmallText :size="14">本文</SmallText>
                <div
                  class="p-modal-notify-thanks-point-denial__body__panel__text"
                >
                  <p data-translate-skip>{{ message }}</p>
                </div>
              </div>
            </li>
          </ul>

          <div class="p-modal-notify-thanks-point-denial__body__reason">
            <SmallText :size="14">否認理由</SmallText>
            <div
              class="p-modal-notify-thanks-point-denial__body__reason__text"
              data-translate-skip
            >
              {{ approverComment }}
            </div>
          </div>
        </div>
        <div class="p-modal-notify-thanks-point-denial__footer">
          <div class="p-modal-notify-thanks-point-denial__footer__item">
            <ButtonMain kind="cancel" @click-button="closeModal">
              閉じる
            </ButtonMain>
          </div>
        </div>
      </div>
    </template>
  </modal-main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import ModalMain from "@/common/components/organisms/ModalMain.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";

import modalState from "@/common/store/modules/modalState";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    user: { type: Object, required: true },
    transaction: { type: Object, required: true },
    reason: { type: String, default: "" }
  },
  components: {
    ModalMain,
    ButtonMain,
    SmallText,
    IconUserImage
  }
})
export default class ModalSelectSendUser extends Vue {
  user!: any;
  transaction!: any;
  reason!: string;

  get colorCode() {
    return commons.colorCode;
  }

  get profileIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 80 : 144;
  }

  get title() {
    return this.transaction?.transaction_details?.title;
  }

  get message() {
    return this.transaction?.transaction_details?.message;
  }

  // DX_IC-815 【バグ】一般画面_サンクスポイントの否認理由に表示されている文言が期待値と異なる
  get approverComment() {
    return this.transaction?.transaction_details?.approver_comment;
  }

  closeModal() {
    modalState.changeModal("");
  }
}
</script>

<style lang="scss" scoped>
.p-modal-notify-thanks-point-denial {
  @include pc {
    width: rem(540);
    padding: rem(48) rem(24) rem(48);
  }
  @include sp {
    width: rem(290);
    padding: rem(32) rem(16) rem(32);
  }
  background-color: $common-white;
  border-radius: rem(4);

  &__header {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  &__avatar {
    @include object-fit("contain");
    width: 100%;
    height: 100%;
  }

  &__name {
    @include pc {
      margin-top: rem(20);
    }

    @include sp {
      margin-top: rem(8);
    }
    font-size: $text-size__body--m;
    display: block;
    width: 100%;
  }

  &__body {
    @include pc {
      margin-top: rem(16);
    }
    @include sp {
      margin-top: rem(24);
    }

    &__reason {
      @include pc {
        font-size: rem(14);
        margin-top: rem(24);
        width: rem(300);
      }
      @include sp {
        font-size: rem(12);
        margin-top: rem(12);
        width: rem(258);
      }
      line-height: (24 / 16);
      margin: 0 auto;
    }

    &__list {
      padding: 2rem 0;
      border-width: 1px 0;
      border-style: solid;
      border-color: #e0e0e0;

      &__item {
        @include pc {
          width: rem(300);
        }
        @include sp {
          width: rem(258);
        }
        margin: 0 auto;

        & + & {
          margin-top: rem(16);
        }
      }
    }

    &__panel {
      &__text {
        font-size: rem(14);
        font-weight: bold;
      }
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: center;

    @include pc {
      padding-top: rem(24);
    }
    @include sp {
      padding-top: rem(32);
    }

    &__item {
      @include sp {
        width: rem(232);
      }

      & + & {
        margin-top: rem(16);
      }
    }
  }
}
</style>
